import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import Icon, { IconDefinition } from '@components/Icon.vue';

import { faCheck } from '@icons/solid/faCheck';
import { faTimes } from '@icons/solid/faTimes';
import { faQuestion } from '@icons/solid/faQuestion';

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    TableCellSuccess: ComponentWithProps<Props>;
  }
}

/**
 * `TableCellSuccess` component properties.
 */
export interface Props {
  /** ... */
  value: unknown;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TableCellSuccess',
  props: {
    value: null
  },
  setup(__props: any) {

const props = __props as {
  /** ... */
  value: unknown;
};



const status = computed(() => {
  let tag: string;
  let icon: IconDefinition;

  if (props.value === true) {
    tag = 'success';
    icon = faCheck;
  } else if (props.value === false) {
    tag = 'fail';
    icon = faTimes;
  } else {
    tag = 'unknown';
    icon = faQuestion;
  }

  return { tag, icon };
});

return { __sfc: true,props, status, Icon }
}

})